import { IMenuItem } from "./IMenuItem";
import { UNKNOWN_MENU_INDEX } from "./const";
import { IPlansBtnContent } from "./Navigation";

export function addTrackingToNavigation(navigation: IMenuItem[]): IMenuItem[] {
  const depth = 0;
  let universe = "";

  navigation.forEach((menuItem: IMenuItem) => {
    universe = menuItem.title;
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    iterateMenu(menuItem, depth, universe);
  });

  return navigation;
}

function iterateMenu(menuItem: IMenuItem, depth: number, universe: string) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  menuItem.tracking = _generateNavTrackingText(menuItem.title, depth, universe);
  if (menuItem.children) {
    menuItem.children.forEach((item: IMenuItem) => {
      iterateMenu(item, depth + 1, universe);
    });
  }
}

export function locateMenuIndexForPath(
  menuItems: IMenuItem[],
  path: string
): number {
  // report if given menu item or any of its children match the given path. Note that it is possible for a menuItem
  // link to have params, so we turn it into a url then get the path.
  function hasPath(menuItem: IMenuItem): boolean {
    const linkURL = new URL(menuItem.link, window.location.href);
    const locationURL = new URL(window.location.href);
    if (linkURL.host == locationURL.host && linkURL.pathname == path) {
      return true;
    }

    return (
      menuItem.children.filter((item: IMenuItem) => {
        return hasPath(item);
      }).length > 0
    );
  }

  for (let i = 0; i < menuItems.length; i++) {
    if (hasPath(menuItems[i])) {
      return i;
    }
  }

  return UNKNOWN_MENU_INDEX;
}

export function locateMenuIndexByHeuristic(
  menuItems: IMenuItem[],
  path: string
): number {
  const paths: string[] = path.split("/");

  if (paths.find((p) => p === "business")) {
    return menuItems.findIndex((menuItem) => menuItem.title === "For Business");
  }

  if (paths.find((p) => p === "for-home")) {
    return menuItems.findIndex((menuItem) => menuItem.title === "For Home");
  }

  if (paths.find((p) => p === "about")) {
    return menuItems.findIndex((menuItem) => menuItem.title === "About Origin");
  }

  return UNKNOWN_MENU_INDEX;
}

export function _generateNavTrackingText(
  title: string,
  depth: number,
  universe: string
): string {
  return `fly:${
    depth === 0 ? "for home" : universe
  }:l${depth}:${title.trim()}`.toLowerCase();
}

export function getLogoLink(
  trackedMenus: IMenuItem[],
  activeIndex: number
): string {
  let logoLink;
  // If the top level nav item is "For Business" & its active: return the business link
  trackedMenus.forEach((trackedMenuItem, index) => {
    if (trackedMenuItem.title === "For Business" && activeIndex === index) {
      logoLink = trackedMenuItem.link;
    }
  });
  return logoLink || "/";
}

export const defaultPlanBtnContent: IPlansBtnContent = {
  label: "See our plans",
  link: "/electricity-gas/plans.html",
};

export const businessPlanBtnContent: IPlansBtnContent = {
  label: "See our plans",
  link: "/business/electricity-and-gas/plans.html",
};

export const internetPlanBtnContent: IPlansBtnContent = {
  label: "Internet plans",
  link: "/sign-up?broadband=true",
};

export function plansBtnContent(path: string): IPlansBtnContent {
  const paths: string[] = path.split("/");
  if (paths.length) {
    if (paths[1].startsWith("internet")) {
      return internetPlanBtnContent;
    }

    if (paths.includes("business")) {
      return businessPlanBtnContent;
    }
  }

  return defaultPlanBtnContent;
}
